import * as React from 'react';

import { useDealSaleOfferLabelState } from './hooks';
import { FormContext } from './utils/formContext';
import { selectIsDealSaleOfferLabelEnabled } from '../../selectors/abExperiments/selectIsDealSaleOfferLabelEnabled';
import { useSelector } from 'react-redux';
import { LabelMapperContainer } from './containers';

/**
 * Контейнер раздела для управления лейблом "Онлайн-сделка" на объявлении.
 */
export const DealSaleOfferLabel: React.FC = () => {
  const { containerType, formContextValue } = useDealSaleOfferLabelState();
  const isBannerShown = useSelector(selectIsDealSaleOfferLabelEnabled);

  if (!isBannerShown) {
    return null;
  }

  return (
    <FormContext.Provider value={formContextValue}>
      <LabelMapperContainer containerType={containerType} />
    </FormContext.Provider>
  );
};
